import React from 'react';
import Modal from 'react-modal';
import '../css/SystemIntegratorView.css';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';


// Distributor view page  component


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};

export default class VideoView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            noOfParams: [],
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            Title: this.props.siCurrentData.title,
            Video: this.props.siCurrentData.video,
            Description: this.props.siCurrentData.description,
            YoutubeVideo: this.props.siCurrentData.yt_video,
            errorMessage: [],

        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {

        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {

    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => this.props.closeAllModal())
            }, 500);

        })
    }



    handleChangeInputBox = (name, event) => {
        this.setState({
            [name]: event
        });
    };

    render() {
        return (
            <React.Fragment>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>VIEW VIDEO</h3>
                    <div className="row">
                        <div className="col-6 mx-0 px-0 disableEvent">
                            <InputBox
                                inputText={this.state.Title}
                                error={false}
                                errorText=""
                                placeholder="Video Title:"
                                inputBoxName="Title"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true}
                            />
                        </div>
                        <div className="col-6  disableEvent"
                        //  style={{paddingLeft: '0px',paddingRight: '0px', marginTop: '10px'}} 
                        >
                            <InputBox
                                inputText={this.state.Video.split("/").pop().split("_")[0]}
                                error={false}
                                errorText=""
                                placeholder="Video File"
                                inputBoxName="Video"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true} />
                        </div>



                        <div className="col-6 mx-0 px-0 disableEvent">
                            <InputBox
                                inputText={this.state.Description}
                                error={false}
                                errorText=""
                                placeholder="Description"
                                inputBoxName="Description"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true} />
                        </div>
                        <div className="col-6 disableEvent">
                            <InputBox
                                inputText={this.state.YoutubeVideo}
                                error={false}
                                errorText=""
                                placeholder="YouTube Video"
                                inputBoxName="YoutubeVideo"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                disableEvent={true} />
                        </div>
                        <div style={{display:'flex', width:'100%', gap:'10px' }}>
                            <div className="col-6  mx-0 px-0" >

                                {/* Show video file name or link if available */}
                                {this.state.Video && (
                                    <div style={{ marginTop: '10px' }}>

                                        <video
                                            controls
                                            src={this.state.Video}
                                            style={{ width: '100%', height: '315px' }}
                                        >
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                )}
                            </div>
                            <div className="col-6  mx-0 px-0">

                                {/* Show video file name or link if available */}
                                {this.state.YoutubeVideo && (
                                    <div style={{ marginTop: '10px' }}>
                                        <iframe
                                            width="100%"
                                            height="315px"
                                            marginTop="10px"
                                            src={`https://www.youtube.com/embed/${(() => {
                                                try {
                                                    const url = new URL(this.state.YoutubeVideo);
                                                    if (url.hostname.includes('youtu.be')) {
                                                        // For short URLs like https://youtu.be/VIDEO_ID
                                                        return url.pathname.slice(1);
                                                    } else if (url.hostname.includes('youtube.com')) {
                                                        // For regular YouTube URLs like https://www.youtube.com/watch?v=VIDEO_ID
                                                        return url.searchParams.get('v');
                                                    }
                                                } catch (error) {
                                                    // console.error("Invalid YouTube URL:", this.state.YoutubeVideo);
                                                    return null;
                                                }
                                            })()}`}
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                )}


                            </div>
                        </div>

                    </div>

                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey " onClick={this.closeModal}>Close</div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
